import React, { useCallback, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FaDeleteLeft } from "react-icons/fa6"

import { delay } from "utils"
import { closePinModal } from "@redux"
import classes from "./PinCodeKeyPads.module.scss"

const pads = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "del", "0", "پاک"]

const PinCodeKeyPads = props => {
  const {
    pin,
    setPin,
    setShowError
  } = props

  const dispatch = useDispatch()

  const cashierPin =
    useSelector(state =>
      state.userAccountInfo.cashierPin
    )

  const validatePin = async (pin) => {
    if (cashierPin === pin) {
      await delay(200)

      dispatch(
        closePinModal()
      )

      setShowError(false)

      await delay(400)

      setPin("")
    } else {
      setPin("")
      setShowError(true)
    }
  }

  const handlePress = pad => {
    if (!pad) return

    if (pad === "پاک") return setPin("")

    if (pad === "del") {
      setPin(prev =>
        prev.substring(0, prev.length - 1)
      )

      return
    }

    const newPin = pin + pad

    setPin(newPin)

    if (newPin.length === 4) validatePin(newPin)
  }

  const handleKeyPress =
    useCallback((e) => {
      let key = ""

      if (!isNaN(e.key)) {
        key = e.key
      }

      if (e.key === "Backspace") {
        key = "del"
      }

      if (e.key === "Delete") {
        key = "پاک"
      }

      if (key === "") return

      handlePress(key)
    }, [pin])

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress)

    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [pin])

  return (
    <div className={classes["container"]}>
      {pads.map(pad =>
        <button
          key={pad}
          className={classes["pad"]}
          onClick={() => handlePress(pad)}
        >
          {pad === "del" ? <FaDeleteLeft /> : pad}
        </button>
      )}
    </div>
  )
}

export default PinCodeKeyPads